<mat-icon *ngIf="numNotifications > 0" class="header-icon" fontSet="fa" fontIcon="fa-bell" [matBadge]="numNotifications"></mat-icon>
<mat-icon *ngIf="numNotifications == 0" class="header-icon" fontSet="fa" fontIcon="fa-bell"></mat-icon>